import NotificationItem from './NotificationItem';
import { Notification } from '../../../store/slices/notification/notificationSlice';

interface Props {
  notifications: Notification[];
  onSelect: (notification: Notification) => void;
}

const NotificationList: React.FC<Props> = ({ notifications, onSelect }) => {
  // =========================================================
  // 📭 Estado vacío
  // =========================================================

  if (notifications.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center px-4 py-8 text-center">
        <p className="text-sm font-medium text-black dark:text-white">
          No hay notificaciones
        </p>

        <p className="mt-1 text-xs text-body dark:text-bodydark">
          Cuando ocurra una actividad importante, aparecerá aquí.
        </p>
      </div>
    );
  }

  // =========================================================
  // 📋 Lista
  // =========================================================

  return (
    <ul
      className="
        scrollbar-thin scrollbar-thumb-bodydark2 scrollbar-track-gray dark:scrollbar-thumb-strokedark
        dark:scrollbar-track-boxdark
        flex
        max-h-[400px]
        flex-col
        overflow-y-auto
      "
    >
      {notifications.map((notification) => (
        <NotificationItem
          key={notification.id}
          notification={notification}
          onClick={onSelect}
        />
      ))}
    </ul>
  );
};

export default NotificationList;
